<template>
  <div>
    <b-card>
      <b-card-body>
        <b-form ref="observer">
          <b-row>
            <b-col lg="4" md="4">
              <b-form-group>
                <PFormSelect
                  v-model="countrySelectedId"
                  :options="optionsCountry"
                  optionValue="id"
                  optionText="descripcion"
                  :label="$t('label.pais')"
                  :placeholder="$t('option.select')"
                  @input="resetTable"
                />
              </b-form-group>
            </b-col>
            <b-col class="switchInput" lg="2" md="2">
              <PFormSwitch v-model="checkTransportadora" :label="$t('label.transportadora')" />
            </b-col>
            <b-col class="switchInput" lg="2" md="2">
              <PFormSwitch v-model="checkAprobacion" :label="$t('label.aprobacionAutomatica')" />
            </b-col>
            <b-col class="switchInput" lg="2" md="2">
              <PFormSwitch v-model="checkTasaEnteros" :label="$t('label.tasaEnteros')" />
            </b-col>
          </b-row>
        </b-form>
        <b-col class="float-right" lg="7" md="7">
          <b-button
            pill
            variant="outline-primary"
            class="p-button-secondary mr-4"
            @click="cancelar"
            >{{ $t("label.cancelar") }}</b-button
          >
          <b-button
            :disabled="!countrySelectedId"
            pill
            variant="primary"
            class="p-button-primary ml-4"
            @click="guardar"
            >{{ $t("label.guardar") }}</b-button
          >
        </b-col>
      </b-card-body>
    </b-card>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import Multiselect from "vue-multiselect";
import { Action, Getter } from "vuex-class";
import { IPaisParams, IPaisResponse } from "@/services";
import { IPais } from "@/entities";
import ColumnasTable from "@/components/administracion/columnas/ColumnasTable.vue";

@Component({
  components: { ColumnasTable, ValidationObserver, Multiselect },
})
export default class AdminPaisesComponent extends Vue {
  @Action("fetchPais")
  fetchPais!: (params?: IPaisParams) => Promise<IPaisResponse | undefined>;

  @Getter("getPaises") optionsCountry!: IPais[];

  private checkTransportadora: boolean | undefined = false;
  private checkAprobacion: boolean | undefined = false;
  private checkTasaEnteros: boolean | undefined = false;

  public countrySelected: IPais | null = null;
  public countrySelectedId: number | null = null;

  constructor() {
    super();
  }

  async resetTable(): Promise<void> {
    this.countrySelected =
      this.optionsCountry.find((pais) => pais.id === this.countrySelectedId) || null;
    if (this.countrySelected) {
      const rest = await this.fetchPais({
        codPais: this.countrySelected.codPais,
        codPaisCorto: this.countrySelected.codPaisCorto,
        codTimezone: this.countrySelected.codTimezone,
        id: this.countrySelected.id,
      });
      if (rest) {
        this.checkTransportadora = rest.content[0].hasTransportadora;
        this.checkAprobacion = rest.content[0].hasAprobacionAutomaticaOferta;
        this.checkTasaEnteros = rest.content[0].hasTasaEnteros;
      } else {
        this.checkTransportadora = false;
        this.checkAprobacion = false;
        this.checkTasaEnteros = false;
      }
    }
  }

  cancelar(): void {
    if (this.countrySelected) {
      this.resetTable();
    } else {
      this.countrySelectedId = null;
      this.checkTransportadora = false;
      this.checkAprobacion = false;
      this.checkTasaEnteros = false;
    }
  }

  guardar(): void {
    if (this.countrySelected) {
      this.$services.pais.saveConfPais({
        codPaisCorto: this.countrySelected.codPaisCorto,
        hasTransportadora: this.checkTransportadora || false,
        hasAprobacionAutomaticaOferta: this.checkAprobacion || false,
        hasTasaEnteros: this.checkTasaEnteros || false,
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.switchInput {
  padding-top: 15px;
}
</style>
